module.exports = __webpack_public_path__ + "img/1.135b0ee9.png";